import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { ConnectedRouter } from 'connected-react-router';
import { SnackbarProvider } from 'notistack';
import { SnackbarHelperConfigurator } from './helpers/snackbarHelper';
import './index.css';
import App from './routes';
import history from './helpers/history';
import store from './store';

ReactDOM.render(
  <Provider store={store}>
    <ConnectedRouter history={history}>
      <SnackbarProvider maxSnack={2}>
        <SnackbarHelperConfigurator />
        <App />
      </SnackbarProvider>
    </ConnectedRouter>
  </Provider>,
  document.getElementById('root')
);
